/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/BoardsExternalIntegrationHub" />
import * as React from "react";
import * as Resources from "Wit/Settings/BoardsExternalIntegration/Resources";
import { IObservableArray, ObservableArray } from "VSS/Core/Observable";
import { ContributedPivotBarItemProvider } from "VSS/Features/Frame/ContributedPivotBarItemProvider";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Hub } from "VSSUI/Hub";
import { HubHeader } from "VSSUI/HubHeader";
import { VssHubViewState } from "VSSUI/Navigation/VssHubViewState";
import { IPivotBarAction } from "VSSUI/PivotBar";
import { IPivotProps } from "Wit/Settings/BoardsExternalIntegration/contracts/Models";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { Link } from "VSSUI/Link";
import { isIE } from "Wit/Settings/BoardsExternalIntegration/utils/BrowserUtil";
import { GitHubConnectionConstants } from "Wit/Settings/BoardsExternalIntegration/constants/Constants";

export class BoardsExternalIntegrationHub extends VssComponent {
    private _hubViewState: VssHubViewState;
    private _pivotCommands: IObservableArray<IPivotBarAction> = new ObservableArray<IPivotBarAction>();
    private _pivotProvider: ContributedPivotBarItemProvider;

    constructor(props: never, context: IVssComponentContext) {
        super(props, context);

        this._initializeHubState(context);
        this._initializePivotProvider(context);
    }

    public render(): JSX.Element {
        return (
            <div className="boards-integration-hub-container">
                {isIE() && (
                    <MessageBar className="ie-message-bar" severity={MessageBarSeverity.Warning}>
                        {Resources.GitHubDoesNotSupportIE}{" "}
                        <Link
                            className="ie-message-bar-learn-more"
                            target="_blank"
                            href={GitHubConnectionConstants.GitHubDoesNotSupportIELearnMoreUrl}
                        >
                            {Resources.LearnMore}
                        </Link>
                    </MessageBar>
                )}
                <Hub
                    className="boards-integration-hub"
                    pivotBarContentClassName="boards-integration-pivot-content"
                    hubViewState={this._hubViewState}
                    hideFullScreenToggle={true}
                    commands={this._pivotCommands}
                    pivotProviders={[this._pivotProvider]}
                >
                    <HubHeader title={Resources.HubHeader} />
                </Hub>
            </div>
        );
    }

    private _initializeHubState(context: IVssComponentContext): void {
        this._hubViewState = new VssHubViewState(context.pageContext);
    }

    private _initializePivotProvider(context: IVssComponentContext): void {
        this._pivotProvider = new ContributedPivotBarItemProvider({
            pageContext: context.pageContext,
            tabGroupIds: ["ms.vss-work-web.boards-repository-integration-tabgroup"],
            getContext: (): IPivotProps => {
                return {
                    updateHubCommands: (commands: IPivotBarAction[]) => {
                        this._pivotCommands.value = commands;
                    }
                };
            }
        });
    }
}

VssComponent.register("BoardsExternalIntegrationHub", BoardsExternalIntegrationHub);
